export const tableOption = (value)=>{
  let that = value
  console.log(that);
  return {
    dialogDrag: true,
    border: true,
    indexLabel: "序号",
    index:true,
    stripe: true,
    menuAlign: "center",
    align: "center",
    menuType: "text",
    searchShow: true,
    dialogClickModal:false,
    dialogWidth:500,
    excelBtn: false,
    printBtn: false,
    addBtn: false,
    viewBtn: false,
    searchSpan:6,
    searchMenuSpan: 6,
    labelWidth:100,
    defaultSort: {
      prop: "purchaseMonth",
      order: "descending",
    },
    column: [
      {
        label: "年月",
        prop: "purchaseMonth",
        sortable: true,
        search: true,
        type:'month',
        valueFormat: 'yyyy-MM',
      },
      {
        label: "泥尾",
        prop: "garbageName",
        sortable: true,
        search:true,
      },
      {
        label: "土质",
        prop: "soilType",
        search: true,
        sortable: true,
      },
      {
        label: "采购总数",
        prop: "qty",
        sortable: true,
      },
      {
        label: "平均成本",
        prop: "price",
        sortable: true,
      },
      {
        label: "采购总金额",
        prop: "purchasePrice",
        sortable: true,
      },
    ],
  };
}

